import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../../../config/firebase";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const EditForm = ({ open, onClose, resource, onResourceUpdated }) => {
  const [formData, setFormData] = useState({
    title: "",
    link: "",
    icon: "",
    iconColor: "",
  });
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    if (resource) {
      setFormData({
        title: resource.title,
        link: resource.link,
        icon: resource.icon,
        iconColor: resource.iconColor,
      });
    }
  }, [resource]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const resourceRef = doc(db, "resources", resource.id);
      await updateDoc(resourceRef, formData);
      setLoading(false);
      onClose();
      onResourceUpdated();
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error updating document: ", error);
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const resourceRef = doc(db, "resources", resource.id);
      await deleteDoc(resourceRef);
      setLoading(false);
      onClose();
      onResourceUpdated();
    } catch (error) {
      console.error("Error deleting document: ", error);
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <ModalDialogTitle onClose={onClose}>Edit Resource</ModalDialogTitle>
        <DialogContent>
          <TextField
            label="Title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Link"
            name="link"
            value={formData.link}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <FormControl fullWidth margin="dense">
            <InputLabel shrink>Icon</InputLabel>
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextField
                name="icon"
                value={formData.icon}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </div>
          </FormControl>
          <FormControl fullWidth margin="dense">
            <InputLabel>Icon Color</InputLabel>
            <Select
              name="iconColor"
              value={formData.iconColor}
              onChange={handleChange}
            >
              <MenuItem value="red">Red</MenuItem>
              <MenuItem value="blue">Blue</MenuItem>
              <MenuItem value="yellow">Yellow</MenuItem>
              <MenuItem value="orange">Orange</MenuItem>
              <MenuItem value="purple">Purple</MenuItem>
              <MenuItem value="green">Green</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <ModalActions
          onSave={handleSave}
          saving={loading}
          onDelete={handleDelete}
        />

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          message="Resource has been updated"
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          ContentProps={{
            sx: {
              backgroundColor: "black",
              color: "white",
            },
          }}
        />
      </Dialog>
    </div>
  );
};

export default EditForm;
